/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccountRouteImport } from './routes/account'
import { Route as CopyrightRouteImport } from './routes/copyright'
import { Route as ForgotRouteImport } from './routes/forgot'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as StartRouteImport } from './routes/start'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as JoinCodeRouteImport } from './routes/join.$code'
import { Route as LSlugRouteImport } from './routes/l.$slug'
import { Route as ModerateIdRouteImport } from './routes/moderate.$id'
import { Route as LSlugIndexRouteImport } from './routes/l.$slug.index'
import { Route as LSlugCatsRouteImport } from './routes/l.$slug.cats'
import { Route as LSlugLeagueRouteImport } from './routes/l.$slug.league'
import { Route as LSlugNextWeekRouteImport } from './routes/l.$slug.next-week'
import { Route as LSlugPostRouteImport } from './routes/l.$slug.post'
import { Route as LSlugResultsRouteImport } from './routes/l.$slug.results'
import { Route as LSlugSeasonsRouteImport } from './routes/l.$slug.seasons'
import { Route as LSlugStandingsRouteImport } from './routes/l.$slug.standings'
import { Route as LSlugVoteRouteImport } from './routes/l.$slug.vote'
import { Route as LSlugSNResultsRouteImport } from './routes/l.$slug.s.$n.results'
import { Route as LSlugSNStandingsRouteImport } from './routes/l.$slug.s.$n.standings'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const CopyrightRoute = CopyrightRouteImport.update({
  id: '/copyright',
  path: '/copyright',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const StartRoute = StartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinCodeRoute = JoinCodeRouteImport.update({
  id: '/join/$code',
  path: '/join/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const LSlugRoute = LSlugRouteImport.update({
  id: '/l/$slug',
  path: '/l/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ModerateIdRoute = ModerateIdRouteImport.update({
  id: '/moderate/$id',
  path: '/moderate/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LSlugIndexRoute = LSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LSlugRoute,
} as any)
const LSlugCatsRoute = LSlugCatsRouteImport.update({
  id: '/cats',
  path: '/cats',
  getParentRoute: () => LSlugRoute,
} as any)
const LSlugLeagueRoute = LSlugLeagueRouteImport.update({
  id: '/league',
  path: '/league',
  getParentRoute: () => LSlugRoute,
} as any)
const LSlugNextWeekRoute = LSlugNextWeekRouteImport.update({
  id: '/next-week',
  path: '/next-week',
  getParentRoute: () => LSlugRoute,
} as any)
const LSlugPostRoute = LSlugPostRouteImport.update({
  id: '/post',
  path: '/post',
  getParentRoute: () => LSlugRoute,
} as any)
const LSlugResultsRoute = LSlugResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => LSlugRoute,
} as any)
const LSlugSeasonsRoute = LSlugSeasonsRouteImport.update({
  id: '/seasons',
  path: '/seasons',
  getParentRoute: () => LSlugRoute,
} as any)
const LSlugStandingsRoute = LSlugStandingsRouteImport.update({
  id: '/standings',
  path: '/standings',
  getParentRoute: () => LSlugRoute,
} as any)
const LSlugVoteRoute = LSlugVoteRouteImport.update({
  id: '/vote',
  path: '/vote',
  getParentRoute: () => LSlugRoute,
} as any)
const LSlugSNResultsRoute = LSlugSNResultsRouteImport.update({
  id: '/s/$n/results',
  path: '/s/$n/results',
  getParentRoute: () => LSlugRoute,
} as any)
const LSlugSNStandingsRoute = LSlugSNStandingsRouteImport.update({
  id: '/s/$n/standings',
  path: '/s/$n/standings',
  getParentRoute: () => LSlugRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRoute
  '/copyright': typeof CopyrightRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/reset': typeof ResetRoute
  '/signup': typeof SignupRoute
  '/start': typeof StartRoute
  '/terms': typeof TermsRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/welcome': typeof WelcomeRoute
  '/join/$code': typeof JoinCodeRoute
  '/l/$slug': typeof LSlugRouteWithChildren
  '/moderate/$id': typeof ModerateIdRoute
  '/l/$slug/cats': typeof LSlugCatsRoute
  '/l/$slug/league': typeof LSlugLeagueRoute
  '/l/$slug/next-week': typeof LSlugNextWeekRoute
  '/l/$slug/post': typeof LSlugPostRoute
  '/l/$slug/results': typeof LSlugResultsRoute
  '/l/$slug/seasons': typeof LSlugSeasonsRoute
  '/l/$slug/standings': typeof LSlugStandingsRoute
  '/l/$slug/vote': typeof LSlugVoteRoute
  '/l/$slug/': typeof LSlugIndexRoute
  '/l/$slug/s/$n/results': typeof LSlugSNResultsRoute
  '/l/$slug/s/$n/standings': typeof LSlugSNStandingsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRoute
  '/copyright': typeof CopyrightRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/reset': typeof ResetRoute
  '/signup': typeof SignupRoute
  '/start': typeof StartRoute
  '/terms': typeof TermsRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/welcome': typeof WelcomeRoute
  '/join/$code': typeof JoinCodeRoute
  '/moderate/$id': typeof ModerateIdRoute
  '/l/$slug/cats': typeof LSlugCatsRoute
  '/l/$slug/league': typeof LSlugLeagueRoute
  '/l/$slug/next-week': typeof LSlugNextWeekRoute
  '/l/$slug/post': typeof LSlugPostRoute
  '/l/$slug/results': typeof LSlugResultsRoute
  '/l/$slug/seasons': typeof LSlugSeasonsRoute
  '/l/$slug/standings': typeof LSlugStandingsRoute
  '/l/$slug/vote': typeof LSlugVoteRoute
  '/l/$slug': typeof LSlugIndexRoute
  '/l/$slug/s/$n/results': typeof LSlugSNResultsRoute
  '/l/$slug/s/$n/standings': typeof LSlugSNStandingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRoute
  '/copyright': typeof CopyrightRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/reset': typeof ResetRoute
  '/signup': typeof SignupRoute
  '/start': typeof StartRoute
  '/terms': typeof TermsRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/welcome': typeof WelcomeRoute
  '/join/$code': typeof JoinCodeRoute
  '/l/$slug': typeof LSlugRouteWithChildren
  '/moderate/$id': typeof ModerateIdRoute
  '/l/$slug/cats': typeof LSlugCatsRoute
  '/l/$slug/league': typeof LSlugLeagueRoute
  '/l/$slug/next-week': typeof LSlugNextWeekRoute
  '/l/$slug/post': typeof LSlugPostRoute
  '/l/$slug/results': typeof LSlugResultsRoute
  '/l/$slug/seasons': typeof LSlugSeasonsRoute
  '/l/$slug/standings': typeof LSlugStandingsRoute
  '/l/$slug/vote': typeof LSlugVoteRoute
  '/l/$slug/': typeof LSlugIndexRoute
  '/l/$slug/s/$n/results': typeof LSlugSNResultsRoute
  '/l/$slug/s/$n/standings': typeof LSlugSNStandingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/account'
    | '/copyright'
    | '/forgot'
    | '/login'
    | '/notifications'
    | '/onboarding'
    | '/privacy'
    | '/reset'
    | '/signup'
    | '/start'
    | '/terms'
    | '/unsubscribe'
    | '/verify'
    | '/welcome'
    | '/join/$code'
    | '/l/$slug'
    | '/moderate/$id'
    | '/l/$slug/cats'
    | '/l/$slug/league'
    | '/l/$slug/next-week'
    | '/l/$slug/post'
    | '/l/$slug/results'
    | '/l/$slug/seasons'
    | '/l/$slug/standings'
    | '/l/$slug/vote'
    | '/l/$slug/'
    | '/l/$slug/s/$n/results'
    | '/l/$slug/s/$n/standings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/account'
    | '/copyright'
    | '/forgot'
    | '/login'
    | '/notifications'
    | '/onboarding'
    | '/privacy'
    | '/reset'
    | '/signup'
    | '/start'
    | '/terms'
    | '/unsubscribe'
    | '/verify'
    | '/welcome'
    | '/join/$code'
    | '/moderate/$id'
    | '/l/$slug/cats'
    | '/l/$slug/league'
    | '/l/$slug/next-week'
    | '/l/$slug/post'
    | '/l/$slug/results'
    | '/l/$slug/seasons'
    | '/l/$slug/standings'
    | '/l/$slug/vote'
    | '/l/$slug'
    | '/l/$slug/s/$n/results'
    | '/l/$slug/s/$n/standings'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/account'
    | '/copyright'
    | '/forgot'
    | '/login'
    | '/notifications'
    | '/onboarding'
    | '/privacy'
    | '/reset'
    | '/signup'
    | '/start'
    | '/terms'
    | '/unsubscribe'
    | '/verify'
    | '/welcome'
    | '/join/$code'
    | '/l/$slug'
    | '/moderate/$id'
    | '/l/$slug/cats'
    | '/l/$slug/league'
    | '/l/$slug/next-week'
    | '/l/$slug/post'
    | '/l/$slug/results'
    | '/l/$slug/seasons'
    | '/l/$slug/standings'
    | '/l/$slug/vote'
    | '/l/$slug/'
    | '/l/$slug/s/$n/results'
    | '/l/$slug/s/$n/standings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccountRoute: typeof AccountRoute
  CopyrightRoute: typeof CopyrightRoute
  ForgotRoute: typeof ForgotRoute
  LoginRoute: typeof LoginRoute
  NotificationsRoute: typeof NotificationsRoute
  OnboardingRoute: typeof OnboardingRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetRoute: typeof ResetRoute
  SignupRoute: typeof SignupRoute
  StartRoute: typeof StartRoute
  TermsRoute: typeof TermsRoute
  UnsubscribeRoute: typeof UnsubscribeRoute
  VerifyRoute: typeof VerifyRoute
  WelcomeRoute: typeof WelcomeRoute
  JoinCodeRoute: typeof JoinCodeRoute
  LSlugRoute: typeof LSlugRouteWithChildren
  ModerateIdRoute: typeof ModerateIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/copyright': {
      id: '/copyright'
      path: '/copyright'
      fullPath: '/copyright'
      preLoaderRoute: typeof CopyrightRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot': {
      id: '/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset': {
      id: '/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$code': {
      id: '/join/$code'
      path: '/join/$code'
      fullPath: '/join/$code'
      preLoaderRoute: typeof JoinCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/l/$slug': {
      id: '/l/$slug'
      path: '/l/$slug'
      fullPath: '/l/$slug'
      preLoaderRoute: typeof LSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/moderate/$id': {
      id: '/moderate/$id'
      path: '/moderate/$id'
      fullPath: '/moderate/$id'
      preLoaderRoute: typeof ModerateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/l/$slug/': {
      id: '/l/$slug/'
      path: '/'
      fullPath: '/l/$slug/'
      preLoaderRoute: typeof LSlugIndexRouteImport
      parentRoute: typeof LSlugRoute
    }
    '/l/$slug/cats': {
      id: '/l/$slug/cats'
      path: '/cats'
      fullPath: '/l/$slug/cats'
      preLoaderRoute: typeof LSlugCatsRouteImport
      parentRoute: typeof LSlugRoute
    }
    '/l/$slug/league': {
      id: '/l/$slug/league'
      path: '/league'
      fullPath: '/l/$slug/league'
      preLoaderRoute: typeof LSlugLeagueRouteImport
      parentRoute: typeof LSlugRoute
    }
    '/l/$slug/next-week': {
      id: '/l/$slug/next-week'
      path: '/next-week'
      fullPath: '/l/$slug/next-week'
      preLoaderRoute: typeof LSlugNextWeekRouteImport
      parentRoute: typeof LSlugRoute
    }
    '/l/$slug/post': {
      id: '/l/$slug/post'
      path: '/post'
      fullPath: '/l/$slug/post'
      preLoaderRoute: typeof LSlugPostRouteImport
      parentRoute: typeof LSlugRoute
    }
    '/l/$slug/results': {
      id: '/l/$slug/results'
      path: '/results'
      fullPath: '/l/$slug/results'
      preLoaderRoute: typeof LSlugResultsRouteImport
      parentRoute: typeof LSlugRoute
    }
    '/l/$slug/seasons': {
      id: '/l/$slug/seasons'
      path: '/seasons'
      fullPath: '/l/$slug/seasons'
      preLoaderRoute: typeof LSlugSeasonsRouteImport
      parentRoute: typeof LSlugRoute
    }
    '/l/$slug/standings': {
      id: '/l/$slug/standings'
      path: '/standings'
      fullPath: '/l/$slug/standings'
      preLoaderRoute: typeof LSlugStandingsRouteImport
      parentRoute: typeof LSlugRoute
    }
    '/l/$slug/vote': {
      id: '/l/$slug/vote'
      path: '/vote'
      fullPath: '/l/$slug/vote'
      preLoaderRoute: typeof LSlugVoteRouteImport
      parentRoute: typeof LSlugRoute
    }
    '/l/$slug/s/$n/results': {
      id: '/l/$slug/s/$n/results'
      path: '/s/$n/results'
      fullPath: '/l/$slug/s/$n/results'
      preLoaderRoute: typeof LSlugSNResultsRouteImport
      parentRoute: typeof LSlugRoute
    }
    '/l/$slug/s/$n/standings': {
      id: '/l/$slug/s/$n/standings'
      path: '/s/$n/standings'
      fullPath: '/l/$slug/s/$n/standings'
      preLoaderRoute: typeof LSlugSNStandingsRouteImport
      parentRoute: typeof LSlugRoute
    }
  }
}

interface LSlugRouteChildren {
  LSlugCatsRoute: typeof LSlugCatsRoute
  LSlugLeagueRoute: typeof LSlugLeagueRoute
  LSlugNextWeekRoute: typeof LSlugNextWeekRoute
  LSlugPostRoute: typeof LSlugPostRoute
  LSlugResultsRoute: typeof LSlugResultsRoute
  LSlugSeasonsRoute: typeof LSlugSeasonsRoute
  LSlugStandingsRoute: typeof LSlugStandingsRoute
  LSlugVoteRoute: typeof LSlugVoteRoute
  LSlugIndexRoute: typeof LSlugIndexRoute
  LSlugSNResultsRoute: typeof LSlugSNResultsRoute
  LSlugSNStandingsRoute: typeof LSlugSNStandingsRoute
}

const LSlugRouteChildren: LSlugRouteChildren = {
  LSlugCatsRoute: LSlugCatsRoute,
  LSlugLeagueRoute: LSlugLeagueRoute,
  LSlugNextWeekRoute: LSlugNextWeekRoute,
  LSlugPostRoute: LSlugPostRoute,
  LSlugResultsRoute: LSlugResultsRoute,
  LSlugSeasonsRoute: LSlugSeasonsRoute,
  LSlugStandingsRoute: LSlugStandingsRoute,
  LSlugVoteRoute: LSlugVoteRoute,
  LSlugIndexRoute: LSlugIndexRoute,
  LSlugSNResultsRoute: LSlugSNResultsRoute,
  LSlugSNStandingsRoute: LSlugSNStandingsRoute,
}

const LSlugRouteWithChildren = LSlugRoute._addFileChildren(LSlugRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccountRoute: AccountRoute,
  CopyrightRoute: CopyrightRoute,
  ForgotRoute: ForgotRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  PrivacyRoute: PrivacyRoute,
  ResetRoute: ResetRoute,
  SignupRoute: SignupRoute,
  StartRoute: StartRoute,
  TermsRoute: TermsRoute,
  UnsubscribeRoute: UnsubscribeRoute,
  VerifyRoute: VerifyRoute,
  WelcomeRoute: WelcomeRoute,
  JoinCodeRoute: JoinCodeRoute,
  LSlugRoute: LSlugRouteWithChildren,
  ModerateIdRoute: ModerateIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
